import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Percent = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.6533 2.6933L12.76 43.0666L17.1333 44.88L37.0266 4.6133L32.6533 2.6933ZM11.64 27.6C17.1866 27.6 20.3333 23.44 20.3333 15.92C20.3333 8.39996 17.1866 4.23996 11.64 4.23996C5.98664 4.23996 2.89331 8.39996 2.89331 15.92C2.89331 23.44 5.98664 27.6 11.64 27.6ZM11.64 23.0666C8.97331 23.0666 7.79998 20.9333 7.79998 15.92C7.79998 10.96 8.97331 8.7733 11.64 8.7733C14.2 8.7733 15.4266 10.9066 15.4266 15.92C15.4266 20.9333 14.2 23.0666 11.64 23.0666ZM38.4133 42.5333C44.0133 42.5333 47.1066 38.3733 47.1066 30.8533C47.1066 23.3333 44.0133 19.1733 38.4133 19.1733C32.8133 19.1733 29.72 23.3333 29.72 30.8533C29.72 38.3733 32.8133 42.5333 38.4133 42.5333ZM38.4133 38C35.8 38 34.5733 35.8666 34.5733 30.8533C34.5733 25.84 35.8 23.7066 38.4133 23.7066C41.0266 23.7066 42.2533 25.84 42.2533 30.8533C42.2533 35.8666 41.0266 38 38.4133 38Z"
        fill={color}
      />
    </svg>
  )
}
